import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/required-uuid-string.js';
export const dismissLeafLinkHeldOrderArgsSchema = z.object({
    heldOrderId: requiredUuidString('Held order is required.', 'Invalid held order.'),
    reason: z
        .string()
        .trim()
        .min(1, 'A dismissal reason is required.')
        .max(500, 'Dismissal reason must be at most 500 characters.'),
});
//# sourceMappingURL=dismiss-leaflink-held-order-args-schema.js.map